/* eslint-disable react/function-component-definition */
import PropTypes from "prop-types";

import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

import MDBox from "components/MDBox";

import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
} from "examples/Sidenav/styles/sidenavCollapse";

import { useMaterialUIController } from "context";

function SidenavCollapse({ icon, name, active, onClick, isParent, expanded, ...rest }) {
  const [controller] = useMaterialUIController();
  const { miniSidenav } = controller;

  const row = (
    <ListItem
      component="li"
      disablePadding
      onClick={onClick}
      sx={{ cursor: onClick ? "pointer" : "default", userSelect: "none" }}
      {...rest}
    >
      <MDBox sx={(theme) => collapseItem(theme, { active, miniSidenav })}>
        <ListItemIcon sx={(theme) => collapseIconBox(theme, { active })}>
          {typeof icon === "string" ? (
            <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
          ) : (
            icon
          )}
        </ListItemIcon>

        <ListItemText primary={name} sx={(theme) => collapseText(theme, { miniSidenav, active })} />

        {/* Click-to-expand chevron for parent items (rotates when open). */}
        {isParent && !miniSidenav && (
          <Icon
            sx={(theme) => ({
              ml: "auto",
              fontSize: "20px !important",
              color: active ? theme.palette.accent.onSurface : theme.palette.ink.secondary,
              transform: expanded ? "rotate(90deg)" : "rotate(0deg)",
              transition: "transform 150ms ease",
            })}
          >
            keyboard_arrow_right
          </Icon>
        )}
      </MDBox>
    </ListItem>
  );

  // Mini mode: rows are icon-only — surface a right tooltip for discoverability.
  if (miniSidenav) {
    return (
      <Tooltip title={name} placement="right">
        {row}
      </Tooltip>
    );
  }

  return row;
}

SidenavCollapse.defaultProps = {
  active: false,
  onClick: null,
  isParent: false,
  expanded: false,
};

SidenavCollapse.propTypes = {
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  isParent: PropTypes.bool,
  expanded: PropTypes.bool,
};

export default SidenavCollapse;
